import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  NoPendingTasksWrapper,
  PendingTasksWrapper,
  WidgetTitle
} from '../../shared/WidgetShared.styles';

import { Wrapper, ActionWrapper, InfoWrapper, TitleWrapper } from './Header.styles';

import { useProfile, useWidgetNextEvents } from '@/store';

export const Header = () => {
  const { events } = useWidgetNextEvents();
  const { profile } = useProfile();
  const { t } = useTranslation('CommonDashboardTranslations');
  const navigateTo = useNavigate();

  const hasAttendableEvents = useMemo(() => {
    return events?.filter(event => {
      const isUserAttending = event.attendees.some(attendee => attendee._id === profile?._id);
      return isUserAttending;
    });
  }, [events, profile]);

  const goToEvents = () => {
    navigateTo('/calendar');
  };

  return (
    <Wrapper>
      <TitleWrapper>
        <WidgetTitle>{t('LIVE_CLASSES')}</WidgetTitle>
        {events?.length === 0 && hasAttendableEvents?.length === 0 ? (
          <NoPendingTasksWrapper>0</NoPendingTasksWrapper>
        ) : (
          <PendingTasksWrapper>
            {t('ATTEND_LIVE_CLASSES_WIDGET', {
              count: hasAttendableEvents?.length,
              total: events?.length
            })}
          </PendingTasksWrapper>
        )}
      </TitleWrapper>
      <InfoWrapper>
        <ActionWrapper onClick={goToEvents}>{t('VIEW_MORE')}</ActionWrapper>
      </InfoWrapper>
    </Wrapper>
  );
};
